<template>
    <div class="card-horizontal" :class="`card-horizontal__${index}`" v-if="facility">
        <div class="card-horizontal__user">
            <div class="card-horizontal__user-left" v-if="facility.user">
                <a class="card-horizontal__user-photo" :href="`/volunteer/${facility.user_id}/profile`">
                    <img :src="`/storage${facility.user.avatar.path.replace('original', 'avatar')}`" alt="user" v-if="facility.user.avatar">
                    <span v-text="getUserPM(facility.user.name)"></span>
                </a>

            </div>
            <div class="card-horizontal__user-right">

                <div class="card-horizontal__user-name d-flex" :class="{'card-horizontal__user-name--with-descr': facility.type === 'giveaway'}">
                    <a :href="`/user/${facility.user_id}/profile`" v-if="facility.type === 'auto_help'">
                        {{facility.name || facility.user.name}}
                    </a>
                    <div v-else-if="facility.type === 'giveaway'">
                        <div v-text="facility.name"></div>
                        <a :href="`/user/${facility.user_id}/profile`">
                            {{facility.user.name}}
                        </a>
                    </div>
                    <a :href="`/user/${facility.user_id}/profile`" v-else>
                        {{facility.user.name}}{{ !facility.type ? '': `, ${facilityDictionary.type}`}}
                    </a>

                </div>

                <template v-if="facility.type === 'giveaway'">
                    <div class="card-horizontal__user-descr">
                        <span class="card-horizontal__user-descr-content" v-html="facility.description.replace(/(<([\/p>])+)>|(<([\/blockquote>][^\/u])+)>/gi, '')"></span>
                        <span class="card-horizontal__user-descr-content-read">... <a href='/facilities/giveaway' class='card-horizontal__user-descr-more'>Читать больше</a></span>
                    </div>
                </template>
                <template v-else-if="facility.type === 'auto_help'">
                    <div class="card-horizontal__user-descr">
                        <span class="card-horizontal__user-descr-content" v-html="facility.description.replace(/(<([\/p>])+)>|(<([\/blockquote>][^\/u])+)>/gi, '')"></span>
                        <span class="card-horizontal__user-descr-content-read">... <a href='/facilities/auto-help' class='card-horizontal__user-descr-more'>Читать больше</a></span>
                    </div>
                </template>
                <template v-else>
                    <div class="card-horizontal__user-descr">
                        <span class="card-horizontal__user-descr-content" v-html="facility.description.replace(/(<([\/p>])+)>|(<([\/blockquote>][^\/u])+)>/gi, '')"></span>
                        <span class="card-horizontal__user-descr-content-read">... <a href='/facilities/pr-photo-help' class='card-horizontal__user-descr-more'>Читать больше</a></span>
                    </div>
                </template>

                <div class="card-horizontal__user-type card-horizontal__user-type--auto-help d-flex" v-if="facility.type === 'auto_help'">{{facilityDictionary.type}}</div>
                <div class="card-horizontal__user-type card-horizontal__user-type--giveaway d-flex" v-else-if="facility.type === 'giveaway'">{{facilityDictionary.giveaway_category}}</div>

                <div class="card-horizontal__user-type card-horizontal__user-type--photo  d-flex" v-else>{{facilityDictionary.type}}</div>
                <div class="card-horizontal__user-paragraph card-horizontal__user-paragraph--row d-flex">
                    <div class="card-horizontal__user-paragraph-item d-flex">
                        <span class="card-horizontal__user-paragraph-icon card-horizontal__user-paragraph-icon--charge"></span>
                        {{facilityDictionary.charge_category}}
                    </div>
                </div>

                <div class="card-horizontal__user-photos d-flex" v-if="facility.images.length">


                    <a class="card-horizontal__user-photos-item" :class="{'card-horizontal__user-photos-item--block': idx < 3}"
                       v-for="(image, idx) in facility.images" :href="`/storage${image.path}`"
                       :data-lightbox="'homestay-' + facility.id"
                       :style="{backgroundImage: image.path ? `url( /storage/${image.path.replace('original', 'preview_l')} )` : 'none'}"></a>

                    <div class="card-horizontal__user-photos-item card-horizontal__user-photos-item--block d-flex" v-if="facility.images.length > 3">
                        +{{facility.images.length - 3}}
                    </div>

                </div>

                <div class="card-horizontal__user-paragraph card-horizontal__user-paragraph--row">
                    <div class="card-horizontal__user-paragraph-item d-flex">
                        <div class="card-horizontal__user-paragraph-title">
                            <span class="lnr lnr-map-marker"></span>Доступность:
                        </div>
                        {{facility.range === 'city' || facility.range === 'region' ? facilityDictionary.arr : facilityDictionary.range}}
                    </div>
                </div>

                <div class="card-horizontal__user-contact d-flex">
                    <a :href="`tel:${facility.user.public_phone}`" v-if="facility.user && facility.user.public_phone" class="card-horizontal__user-contact-link card-horizontal__user-contact-link--icon">Позвонить</a>
                    <template v-if="facility.type === 'giveaway'">
                        <a href="/facilities/giveaway" class="card-horizontal__user-contact-link card-horizontal__user-contact-link--primary">Отправить заявку</a>
                    </template>
                    <template v-else-if="facility.type === 'auto_help'">
                        <a href="/facilities/auto-help" class="card-horizontal__user-contact-link card-horizontal__user-contact-link--primary">Отправить заявку</a>
                    </template>
                    <template v-else>
                        <a href="/facilities/pr-photo-help" class="card-horizontal__user-contact-link card-horizontal__user-contact-link--primary">Отправить заявку</a>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Helps",
    props: ['facility', 'index'],
    data(){
        return{}
    },

    computed: {

        facilityDictionary(){

            let object = (({type, range, charge_category,cities,regions, giveaway_category = null}) =>
                ({type, range, charge_category,arr:[...cities,...regions], giveaway_category}))(this.facility)


            if(object.type === 'giveaway'){
                switch(object.giveaway_category){
                    case 'medical':
                        object.giveaway_category = 'Медикаменты и реабилитация'
                        break;
                    case 'nutrition':
                        object.giveaway_category = 'Корм'
                        break;
                    case 'other':
                        object.giveaway_category = 'Другое'
                        break;
                    default:
                        object.giveaway_category = ''
                }

            }

            switch (object.type){
                case 'photo_help':
                    object.type = 'Фотопомощь'
                    break;
                case 'pr_help':
                    object.type = 'PR'
                    break;
                case 'auto_help':
                    object.type = 'Автопомощь'
                    break;
                case 'giveaway':
                    object.type = 'Отдам даром'
                    break;
                default:
                    object.type = ''
            }



            switch (object.range){
                case 'city':
                case 'region':
                    object.arr = object.arr.map(item => item.name).join(', ')
                    break;
                case 'country':
                    object.range = 'по всей стране'
                    break;
                case 'abroads':
                    object.range = 'по всей стране и за ее пределами'
                    break;
                default:
                    object.range = ''
            }

            switch (object.charge_category){
                case 'free':
                    object.charge_category = 'Бесплатно'
                    break;
                case 'paid_for':
                    object.charge_category = 'Платно'
                    break;
                case 'cost_recovery':
                    object.charge_category = 'Возмещение затрат'
                    break;
                default:
                    object.charge_category = ''
            }



            return object

        },
    },

    methods:{

        getUserPM(name){
            if(!name) {
                return '';
            }
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },
    }
}
</script>

<style scoped>

</style>
